import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ButtonLoader from '../Button Loader/Loader';

function ConfirmationModal({
  isModalVisible,
  title,
  content,
  onOkBtn,
  onCancelBtn,
  loader,
}) {
  return (
    <Modal isOpen={isModalVisible}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{content}</ModalBody>
      <ModalFooter>
        <Button color='success' onClick={onOkBtn}>
          {loader && <ButtonLoader />}
          تایید
        </Button>
        <Button color='danger' onClick={onCancelBtn}>
          انصراف
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmationModal;
